const PASS_RULES = [
  { icon: "ri-eye-line", title: "真实可考", desc: "有明确来源或亲身见证，关键细节经得起推敲，不存在编造臆想。" },
  { icon: "ri-chat-3-line", title: "客观中立", desc: "叙述以事实为主，立场表达清晰但不过度煽动、不引导网暴。" },
  { icon: "ri-align-justify", title: "信息完整", desc: "起因、经过、结果齐全，时间地点角色交代清楚，读得懂、有来龙去脉。" },
  { icon: "ri-shield-check-line", title: "符合规范", desc: "格式规整、字数合适、隐私打码到位，配图授权清晰。" },
];

const REJECT_RULES = [
  { icon: "ri-user-unfollow-line", title: "辱骂攻击", desc: "含人身攻击、污言秽语、煽动对立或网暴倾向的内容不予通过。" },
  { icon: "ri-error-warning-line", title: "造谣传谣", desc: "无依据的夸大、捏造、恶意带节奏内容，一经发现从严处理。" },
  { icon: "ri-lock-password-line", title: "泄露隐私", desc: "未经打码公开他人电话、住址、证件等隐私信息，直接拒绝并记录。" },
  { icon: "ri-vip-crown-line", title: "侵权抄袭", desc: "搬运、洗稿、盗图或侵犯版权的内容，一律不通过并可能封禁。" },
  { icon: "ri-forbid-line", title: "违法违规", desc: "涉及违法、黄赌毒等违规内容，拒绝受理并可能提交相关方处理。" },
];

export default function Review() {
  return (
    <section id="review" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-medium text-primary-700">
            <i className="ri-shield-check-line"></i> 审核标准
          </span>
          <h2 className="mt-4 font-display text-3xl text-foreground-900 md:text-4xl">
            哪些瓜能过，哪些瓜要撤
          </h2>
          <p className="mt-3 text-foreground-700">
            审核不是看心情，而是照着明确的尺子量。了解下面两条标准，投稿前就能自己先过一遍。
          </p>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2">
          {/* 通过标准 */}
          <div className="rounded-2xl border border-accent-200 bg-accent-50/50 p-6 md:p-8">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-check-double-line text-xl"></i>
              </span>
              <div>
                <h3 className="text-xl font-bold text-foreground-900">✅ 通过标准</h3>
                <p className="text-sm text-foreground-600">满足这些，瓜料更容易过审</p>
              </div>
            </div>
            <ul className="mt-6 space-y-4">
              {PASS_RULES.map((rule) => (
                <li key={rule.title} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                    <i className={rule.icon}></i>
                  </span>
                  <div>
                    <p className="font-bold text-foreground-900">{rule.title}</p>
                    <p className="mt-0.5 text-sm leading-6 text-foreground-700">{rule.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* 打回标准 */}
          <div className="rounded-2xl border border-primary-200 bg-primary-50/50 p-6 md:p-8">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-close-circle-line text-xl"></i>
              </span>
              <div>
                <h3 className="text-xl font-bold text-foreground-900">✕ 不予通过</h3>
                <p className="text-sm text-foreground-600">触及这些红线，直接打回</p>
              </div>
            </div>
            <ul className="mt-6 space-y-4">
              {REJECT_RULES.map((rule) => (
                <li key={rule.title} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className={rule.icon}></i>
                  </span>
                  <div>
                    <p className="font-bold text-foreground-900">{rule.title}</p>
                    <p className="mt-0.5 text-sm leading-6 text-foreground-700">{rule.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}